<template>
  <div class="ml-0 ml-lg-15">
    <v-menu offset-y transition="slide-y-transition" class="header-user-popup">
      <template v-slot:activator="{ on, attrs }">
        <div :class="expireSoon ? 'm-top' : ''">
          <div class="d-flex justify-center">
            <v-chip class="expire-class" x-small color="#C4622D" dark v-if="expireSoon">
              <v-icon x-small left>fa-thin fa-triangle-exclamation</v-icon>
              Expiring Soon</v-chip
            >
            <v-btn
              v-if="$vuetify.breakpoint.lgAndUp"
              icon
              class="user-icon"
              v-bind="attrs"
              v-on="on"
              large
            >
              <v-icon>fa-user</v-icon>
            </v-btn>
            <v-btn
              v-if="$vuetify.breakpoint.mdAndDown"
              icon
              class="user-icon"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon>fa-user</v-icon>
            </v-btn>
          </div>
        </div>
      </template>

      <div class="header-user-container" v-if="description">
        <div class="header-user-desc pa-4">
          <span>
            {{ this.description }}
          </span>
          <div class="mb-2 expire-div" v-if="expireSoon">
            <v-icon small color="#C4622D"> fa-regular fa-triangle-exclamation </v-icon>
            Expiring soon
          </div>
        </div>

        <div class="item-container">
          <div class="my-2">
            <div
              class="mini-menu-item px-4 py-2 d-flex align-center"
              @click="openProfileFuncClicked()"
            >
              <i class="fa-light fa-address-card icon-color fa-xl pr-1"></i>
              <span>My profile</span>
            </div>

            <div
              class="mini-menu-item px-4 py-2 d-flex align-center"
              @click="myCertificateFunClicked()"
            >
              <i class="fa-light fa-file-certificate icon-color fa-xl pr-1"></i>
              <span>My certificate</span>
            </div>
          </div>

          <div class="pa-4 mini-menu-item item-border" @click="logoutFuncClicked()">
            <i
              class="fa-light fa-arrow-right-from-bracket icon-color fa-xl pr-1 pl-1"
            ></i>
            <span>Sign out</span>
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: ["expireSoon", "description"],
  methods: {
    openProfileFuncClicked() {
      this.$emit("openProfile");
    },
    myCertificateFunClicked() {
      this.$emit("myCertificate");
    },
    logoutFuncClicked() {
      this.$emit("logoutClicked");
    },
  },
  computed: {
    size() {
      const size = {
        xs: "small",
        sm: "small",
        md: "small",
        lg: "large",
        xl: "large",
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
  },
};
</script>
<style lang="scss">
.expire-class {
  position: absolute;
  z-index: 999;
  margin-top: -10px;
}
.user-icon {
  background-color: #e8e8e8 !important;
}
.profile-default-size {
  font-size: 14px !important;
}
.profile-lg-size {
  font-size: 48px !important;
}
.expire-div {
  color: #c4622d;
  font-size: 0.8rem;
}
.item-container {
  width: 15rem;
}
.icon-color {
  color: #5e6466;
}
.mini-menu-item:hover {
  background-color: #ececec;
  cursor: pointer;
}
.item-border {
  border-top: 1px solid #e8e8e8;
}
.header-user-container {
  overflow-y: auto;
  background-color: #ffffff;
}
</style>
